<!--
2022-08-06 HHY 将this.takeNum从15改为10000以不让veiw more 按钮显示
2022-10-05 HHY 将less全局变量@height从70%变为60%
-->
<template>
  <div class="gamePage">
    <div id="bannerListDiv" class="banner-list-wrapper pointer" @mouseenter="showPrevAndNext"
         @mouseleave="hidePrevAndNext">
      <Swipe
        ref="swipe"
        :auto="7500"
        v-if="bannerList && bannerList.length > 0"
        @change="handleChange"
        :showIndicators="false"
      >
        <SwipeItem
          v-for="(item, i) in bannerList"
          :key="'p' + i"
        >
          <div class="carousel-item">
            <img
              :alt="item.Name"
              :src="item.ImageSrc"
              class="banner-image"
              @click="bannerAction(item.Type, item.RedirectPath, item.RedirectParams, item.IframeControlProperty, item.ModalControlProperty)"
            >
          </div>
        </SwipeItem>
      </Swipe>
      <div class="progress_btn left" @click="handlePrev" v-if="bannerList && bannerList.length > 1 && showControl">《</div>
      <div class="progress_btn right" @click="handleNext" v-if="bannerList && bannerList.length > 1 && showControl">》</div>
      <div class="indicators" v-if="bannerList && bannerList.length > 1 && showControl">
        <div class="indicator"
             v-for="(item,index) in bannerList" :key="'in'+index"
             :class="{ 'is-active': index === mySwipeIndex }"
             @click="handleControl(index)"
        >
        </div>
      </div>
    </div>
    <div class="selectContainer">
      <div class="selectList">
        <div class="selectItem pointer" :class="{'labelAct':showType===item.value}" v-for="(item, index) in topList" :key="index" @click="selectType(item.value)">
          <img :src="showType===item.value?item.srcAct:item.src" alt="">
          <div>{{item.label}}</div>
        </div>
      </div>
<!--      <div class="live-wrapper">
        <div class="user-count-wrapper">
          <div>
            <span>{{$t('lang.winner.live')}}</span>
          </div>
          <div>
            <span>{{$t('lang.winner.players')}}</span>
          </div>
        </div>
        <div class="user-count" v-show="livePlayersCount > 0">
          <span>{{separateThousandInteger(livePlayersCount)}}</span>
        </div>
      </div>-->
      <div class="searchRow">
        <label>
          <input type="text" v-model="searchText" @keydown.enter="searchGamesBy">
        </label>
        <img :src="imgList['search']" alt="" @click="searchGamesBy">
      </div>
    </div>
    <div class="providerRow" v-if="hasProviderTypes.includes(showType)">
      <div class="provider pointer"
           :class="{act: provider.Name === item.Name}"
           v-for="(item, index) in providersList"
           :key="index"
           @click="selectProvider(item)">
        <img :src="item.Images" alt="">
      </div>
    </div>
    <div class="gameContainer">
      <div ref="gameContent" class="gameContent">
        <div ref="scroll">
          <div
            class="game"
            :class="{'last': index%5===4}"
            v-for="(item, index) in gameList"
            :key="index"
            @click="fetchGame(item)"
          >
            <div class="imgContainer" @mouseover="(e) => {
              togglePlay(e, true)
            }" @mouseleave="(e) => {
              togglePlay(e, false)
            }">
              <div class="playContainer">
                <div>
                  <p>{{item.GameNameEn || 'Game'}}</p>
                  <div class="play">{{$t('lang.common.play')}}</div>
                </div>
              </div>
              <div class="img" :style="`background-image:url(${item.ThumbnailUrl})`" />
              <div class="imgMask pointer"/>
            </div>
          </div>
        </div>
      </div>
      <div class="loadMore pointer" @click="searchGames(true)"  v-if="gameList.length&&!hasLoadAll">{{$t('lang.common.viewMore')}}</div>
    </div>
    <IFrame3Part
      :iFrameSrc="iFrameSrc"
      :handelClose="() => handleCloseIFrame3Part('showTournament')"
      v-if="showTournament"
    >
    </IFrame3Part>
  </div>
</template>

<script>
import 'mint-ui/lib/style.css'
import config from '../../../static/config/config'
import {Swipe, SwipeItem} from 'mint-ui'
import request from '@/service'
import GameIframe from '@/components/GameIframe/index'
import {mapMutations} from 'vuex'
import {separateThousandInteger} from '@/utils'
import IFrame3Part from '@/components/IFrame3Part/index'

const context = require.context('@/assets/images/GamePage', true, /\.svg$/)
const imgList = {}
context.keys().forEach((key) => {
  imgList[key.replace('./', '').replace('.svg', '')] = context(key)
})

export default {
  name: 'Games',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      imgList,
      providersList: [],
      topList: [],
      iFrameSrc: '',
      showTournament: false,
      iframeControlProperty: false,
      showType: '',
      provider: '',
      allGames: {},
      gameList: [],
      takeNum: 15,
      skipNum: 0,
      totalNum: 0,
      hasLoadAll: true,
      gameInfo: {},
      showGame: false,
      searchText: '',
      showControl: false,
      allLocaleBanners: [],
      webIcons: [],
      bannerList: [],
      bannerInterval: null,
      mySwipeIndex: 0,
      livePlayersCount: 0, // added by HHY 20220525
      separateThousandInteger, // added by HHY 20220525
      liveInterval: null, // added by HHY 20220525
      liveTimeout: null, // added by HHY 20220525
      hasProviderTypes: []
    }
  },
  components: {
    Swipe,
    SwipeItem,
    GameIframe,
    IFrame3Part
  },
  created () {
    this.getBannerList()
  },
  // 2021-08-29 C007 修改使用internal/allgames接口，增加userId和county参数
  mounted () {
    let data = {
      userId: this.userInfo.userId,
      internation: this.$store.state.internation
    }
    request('post', '/innovation/internal/allgames', data).then(res => {
      this.allGames = res
      this.selectType(this.showType || 'MostPopular') // Hot Games is default
    })
    this.fetchLiveUsersCount() // added by HHY 20220525 for getting live person count
    this.liveInterval = setInterval(() => { // added by HHY 20220525 for refreshing to get live person count at a specific time interval
      this.randomTimeout()
    }, 30000)
  },
  methods: {
    ...mapMutations({
      setGameInfo: 'setGameInfo',
      setCurrentRoute: 'setCurrentRoute'
    }),
    showPrevAndNext () {
      this.showControl = true
    },
    hidePrevAndNext () {
      this.showControl = false
    },
    handlePrev () {
      this.$refs.swipe.prev()
    },
    handleNext () {
      this.$refs.swipe.next()
    },
    handleControl (index) {
      if (index === this.mySwipeIndex) {
        return
      }
      if (index < this.mySwipeIndex) {
        this.$refs.swipe.prev()
      } else {
        this.$refs.swipe.next()
      }
    },
    handleChange (index) {
      this.mySwipeIndex = index
    },
    bannerAction: function (type, path, param, iframeControlProperty, modalControlProperty) {
      switch (type) {
        case 'GoToRoute':
          if (path) {
            if (path.toLowerCase().indexOf('games') > -1 || path.toLowerCase().indexOf('home') > -1) { // 跳转本页的游戏类型
              if (path.toLowerCase().indexOf('category=') > -1) {
                this.selectType(path.split('=')[1])
                return
              }
              if (param) {
                this.selectType(param)
              }
            } else {
              if (param) {
                this.$router.push({path: path, query: {param: param}})
              } else {
                this.$router.push({path: path})
              }
            }
          }
          break
        case 'PlayGame':
          this.fetchGame(param)
          break
        case 'ShowIframe':
          if (this.userInfo) {
            this['showTournament'] = true // Banner中需要跳转到第三方页面的, 以iFrame形式显示
            this.iFrameSrc = path
          } else {
            this.$router.push('/Login')
          }
          break
      }
    },
    togglePlay (e, show) {
      if (e.currentTarget === undefined || e.currentTarget === null) {
        return
      }
      if (show) {
        e.currentTarget.children[0].style.top = '0'
      } else {
        e.currentTarget.children[0].style.top = '-100%'
      }
    },
    selectType (type) {
      this.hasProviderTypes = []
      if (type === 'MostPopular') {
        this.takeNum = 10000 // 2022-08-06 HHY 将其值从15改为10000以不让veiw more 按钮显示
      } else {
        this.takeNum = 15
      }

      this.$refs.gameContent.scrollTop = 0
      this.showType = type
      const games = this.allGames.filter((e) => {
        return e.Name === type
      })[0]
      if (games && games.ProviderItems && games.ProviderItems.length > 0) {
        let that = this
        this.totalNum = 0
        this.hasProviderTypes.push(type)
        games.ProviderItems.forEach((e) => { // 有游戏上的分类
          if (e.games && e.games.length > 0) {
            that.totalNum += e.games.length
          }
        })
        this.provider = games.ProviderItems[0]
        this.providersList = games.ProviderItems
      } else {
        this.totalNum = games.Games.length
      }
      this.searchGames()
    },
    selectProvider (key) {
      this.provider = key
      let games = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0]
      this.totalNum = games.ProviderItems.filter((provider) => {
        return provider.Name === key.Name
      }).length
      this.searchGames()
    },
    searchGames (loadMore) {
      if (!loadMore) {
        this.skipNum = 0
        this.gameList = []
        this.firstLoad = true
        this.hasLoadAll = true
      }
      this.hotBanners = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0].HotBanner
      const game = this.allGames.filter((item) => {
        return item.Name === this.showType
      })[0]
      if (this.hasProviderTypes.includes(this.showType)) {
        this.gameList = game.ProviderItems.filter((item) => {
          return item.Name === this.provider.Name
        })[0].Games
      } else {
        this.gameList = game.Games
      }
      this.skipNum += this.takeNum
      this.hasLoadAll = true // this.gameList.length >= this.totalNum
      if (!this.firstLoad) {
        this.$refs.loadmore.onBottomLoaded()
      }
      this.firstLoad = false
    },
    searchGamesBy () { // 根据条件搜索 by HHY 20220529
      if (this.searchText.trim() === '') {
        return // 搜索条件为空时，不执行任何操作
      }
      this.showType = '' // selection nav 都设置为 inactive
      this.gameList = []
      const keys = Object.keys(this.allGames)
      keys.forEach(key => {
        const games = this.allGames[key]
        for (var index in games) { // 循环一级游戏列表
          const game = games[index]
          const len = game.length
          if (len === undefined) {
            for (var k in game) { // 遍历一个游戏JSON对象中的KV信息
              if (k === 'GameNameEn') {
                const v = game[k] // 取值
                if (v.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) { // 均转换为小写进行游戏名匹配
                  this.gameList.push(game)
                }
              }
            }
          } else if (len > 0) { // 如果还有下级游戏
            const subgames = game // 下级游戏
            for (var indx in subgames) { // 循环二级游戏列表
              const subgame = subgames[indx]
              const len = subgame.length
              if (len === undefined) {
                for (var subk in subgame) { // 遍历一个游戏JSON对象中的KV信息
                  if (subk === 'GameNameEn') {
                    const v = subgame[subk] // value
                    if (v.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
                      this.gameList.push(subgame) // 如果匹配到，就加入显示列表
                    }
                  }
                }
              }
            }
          }
        }
      })
      this.hasLoadAll = true // 不显示view more按钮
      this.filterRepetition(this.gameList)
    },
    filterRepetition (arr) { // 游戏搜索结果去重 By HHY20220530
      const map = new Map()
      let list = arr.filter((item) => !map.has(item['GameNameEn'] + '') && map.set(item['GameNameEn'] + '', 1))
      this.gameList = list
    },
    fetchGame (game) {
      if (this.userInfo && this.$store.state.banUserId.includes(this.userInfo.UserId)) {
        this.$message.error(this.$t('lang.home.gameMaintenancePrompt'))
        return
      }
      const url = '/innovation/game/getgameurl'
      const data = {
        userId: this.userInfo.UserId || '',
        gameCode: game.GameCode,
        gameProviderId: game.GameProviderId,
        deviceWidth: 1125,
        lang: localStorage.getItem('locale'),
        internation: this.$store.state.internation,
        Platform: 'web',
        campaignId: localStorage.getItem('cid'),
        localVersion: config.version,
        localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
      }
      request('post', url, data).then(res => {
        if (res.status === 401) return
        if (res.Url) {
          this.gameInfo = {
            showIframe: true,
            gameUrl: res.Url,
            gameName: game.GameNameEn
          }
          this.setGameInfo(this.gameInfo)
        } else {
          this.$message.error(this.$t('lang.common.fail'))
        }
      })
    },
    handleCloseIFrame3Part (iframeControlProperty) {
      this[iframeControlProperty] = false
    },
    getBannerList () { // added by HHY 20220525 for getting top banner info
      const url = '/innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid')
      if (!this.userInfo) {
        cid = null
      }
      let data = {IsApp: 0, CampaignId: cid}
      request('post', url, data, true).then(res => {
        this.bannerList = res.HomeBanners
        this.allLocaleBanners = res.HomeBanners
        this.webIcons = res.WebIcons
        if (this.bannerList && this.bannerList.length > 0) {
          let locale = this.$store.state.locale
          this.bannerList = this.bannerList.filter((item) => {
            if (item.InternationCode === locale) {
              return item
            }
          })
        }
        this.loadIcons()
      }).catch(err => {
        console.log(err)
      })
    },
    loadIcons () {
      if (this.webIcons && this.webIcons.length > 0) {
        let tempList = [
          {
            label: this.$t('lang.label.hot'),
            value: 'MostPopular'
          },
          {
            label: this.$t('lang.label.live'),
            value: 'LiveCasino'
          },
          {
            label: this.$t('lang.label.lottery'),
            value: 'Lottery'
          },
          {
            label: this.$t('lang.label.fishing'),
            value: 'FishingGames'
          },
          {
            label: this.$t('lang.label.slots'),
            value: 'SlotGames'
          },
          {
            label: this.$t('lang.label.sports'),
            value: 'SportsGames'
          },
          {
            label: this.$t('lang.label.card'),
            value: 'Card'
          },
          {
            label: this.$t('lang.label.crash'),
            value: 'CrashGames'
          }
        ]
        this.topList = []
        this.webIcons.forEach(icon => {
          let temp = tempList.find(t => t.value === icon.Name)
          if (temp) {
            temp.src = icon.Image
            temp.srcAct = icon.ImageActive
            this.topList.push(temp)
          }
        })
        this.showType = this.topList[0].value
      }
    },
    fetchLiveUsersCount () { // added by HHY 20220525 for getting live user count
      // request('post', '/innovation/home/getliveusercount', {
      //   internation: this.$store.state.internation
      // }, true).then(res => {
      //   if (res) {
      //     this.livePlayersCount = res.livePlayersCount
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    randomTimeout () { // added by HHY 20220525 for refreshing time out
      this.liveTimeout = setTimeout(() => {
        this.fetchLiveUsersCount()
      }, Math.random() * 10000)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      switch (vm.$route.query.type) {
        case 'casino':
          vm.showType = 'LiveCasino'
          break
        case 'slots':
          vm.showType = 'SlotGames'
          break
      }
    })
  },
  beforeDestroy () { // added by HHY 20220525
    clearTimeout(this.liveTimeout)
    clearInterval(this.liveInterval)
  },
  watch: { // added by HHY for watch the dynamic change of the $route.query,in order to get to LiveCasino or SlotGames page from clicking footer Live Casino or Slots link 20220527
    $route () {
      if (this.$route.query.type !== undefined) {
        this.showType = this.$route.query.type
        const path = this.$route.path // 先获取路由路径
        this.$router.push(path) // 再跳转路由路径，query参数没带，被清除
        this.setCurrentRoute('')
        this.selectType(this.showType)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @height: 60%;

::-webkit-scrollbar-track {
 background-color: #FFE39B;
}

::-webkit-scrollbar-thumb {
 width: 1px;
 background-color: rgba(0, 0, 0, .35);
 border-radius: 100px;
}

::-webkit-scrollbar {
 width: 5px; // 纵向滚动条宽度
 height: 5px; // 横向滚动条高度
}

  .gamePage {
    height: 100%;
    background-color: #000;
    .selectContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 110px;
      overflow: auto;
      padding: 0 122px;
      background-color: #151515;
      .selectList {
        display: flex;
        align-items: center;
        /*padding-left: 35px;*/
        /*width: max-content;*/
        .selectItem {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          margin-right: 25px;
          flex: 1;
          img {
            width: 44px;
          }
          div {
            font-size: 16px;
            line-height: 16px;
            margin-top: 17px;
            width: 100%;
            min-width: max-content;
          }
        }
        .labelAct {
          img {
            width: 44px;
          }
          div {
            color: #F6D9AA;
          }
        }
      }
      .searchRow {
        position: relative;
        height: 40px;
        input {
          width: 100%;
          height: 100%;
          background-color: #000;
          font-size: 16px;
          color: #686868;
          border-radius: 6px;
          padding-left: 17px;
          padding-right: 50px;
          // direction: rtl;
          text-align: right;
        }
        img {
          position: absolute;
          top: 50%;
          right: 7px;
          transform: translateY(-50%);
        }
      }
    }
    .providerRow {
      height: 55px;
      width: 100%;
      overflow: auto;
      margin: 15px auto 0;
      padding: 0 50px;
      background-color: #121212;
      display: flex;
      border-radius: 52px;
      .provider {
        position: relative;
        /*flex: 1;*/
        display: flex;
        align-items: center;
        margin-right: 37px;
        &:last-child {
          margin-right: 0;
        }
        img {
          height: 36px;
          /*width: 100%;*/
        }
      }
      .act {
        border-bottom: 2px solid #F6D9AA;
      }
    }
    .gameContainer {
      /*height: calc(100% - 100px);*/
      padding: 10px 122px;
      margin-bottom: 30px;
      .gameContent {
        height: calc(100% - 60px);
        margin-top: 20px;
        overflow: auto;
        .game {
          width: 19%;
          margin-right: 1.25%;
          margin-bottom: 20px;
          float: left;
          .imgContainer {
            position: relative;
            height: 0;
            padding-bottom: @height;
            overflow: hidden;
            border-radius: 6px;
            .playContainer {
              position: absolute;
              top: -100%;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 6px;
              transition: top .3s;
              >div {
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                text-align: center;
                p {
                  font-family: Roboto-Medium, sans-serif;
                  max-width: 80%;
                  font-size: 20px;
                  color: #ffffff;
                  margin: 0 auto 15px;
                  padding-bottom: 15px;
                  border-bottom: 1px solid #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .play {
                  margin: 0 auto;
                  font-size: 18px;
                  line-height: 30px;
                  width: 150px;
                  color: #F6D9AA;
                  background: rgba(246, 217, 170, 0.1);
                  border: 1px solid #F6D9AA;
                  border-radius: 6px;
                }
              }
            }
            img {
              width: 100%;
              border-radius: 6px;
            }
            .img {
              padding-bottom: @height;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
            }
            .imgMask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 58.82%, #000000 120%);
            }
          }
        }
        .last {
          margin-right: 0;
        }
      }
      .loadMore {
        font-family: Roboto-Medium, sans-serif;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #8C5400;
        text-align: center;
        padding: 10px 40px;
        margin: 20px auto;
        background: #FFE39B;
        border-radius: 31px;
        width: max-content;
      }
    }

    .banner-list-wrapper {
      position: relative;
      height: 35vw;
      .indicators{
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 1vw;
        width: max-content;
        height: max-content;
        display: flex;
        .indicator{
          width: 10px;
          height: 10px;
          display: inline-block;
          border-radius: 100%;
          background: #000;
          opacity: .5;
          margin: 0 3px;
        }

        .is-active {
          background: #717171;
          opacity: 1;
        }
      }
      .progress_btn{
        height: 100%;
        background-color: rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.2);
        font-size: 5vw;
        line-height: 35vw;
      }
      .left{
        position: absolute;
        top: 0;
        left: -2vw;
      }

      .right {
        position: absolute;
        top: 0;
        right: -2vw;
      }
    }
    .banner-image {
      width: 100%;
    }
    .live-wrapper{
        background: #000000;
        padding: 6px 4px 6px 8px;
        margin: 0 40px 0 20px;
        display: flex;

        .user-count-wrapper {
          padding: 2px 0px;
          width: 60px;
          line-height: 12px;
          background: #FF1B1B;
          color: #FFFFFF;
          text-align: center;
          font-size: 12px;
        }

        .user-count {
          line-height: 28px;
          font-size: 14px;
          color: #F6D9AA;
          width: 50px;
          text-align: center;
          // border-right: 1px solid #FF1B1B;
          // border-left: 1px solid #F6D9AA;
          white-space: nowrap;
          overflow: hidden;
        }
    }
    .sperateDiv{
       width: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Games/index.vue